import {Component, Input, OnInit} from '@angular/core';
import {ProleisObject} from "proleis-rest-client";

@Component({
  selector: 'p4m-tracking-table',
  templateUrl: './tracking-table.component.html',
  styleUrls: ['./tracking-table.component.scss']
})
export class TrackingTableComponent implements OnInit {

  displayedColumns: string[] = ['work', 'task', 'serviceType', 'ratingType',
    'order', 'project', 'bemi', 'pos', 'incident', 'comment'];

  @Input() trackings: ProleisObject[];

  ngOnInit() {
    this.calculateDisplayedColumns();
  }

  calculateDisplayedColumns() {
    this.displayedColumns = this.displayedColumns.filter(column => {
      switch (column) {
        case 'work':
          return this.trackings.some(tracking => tracking.STUNDEN);
        case 'task':
          return this.trackings.some(tracking => tracking.AFOBEZ);
        case 'serviceType':
          return this.trackings.some(tracking => tracking.LEISTUNGSART);
        case 'ratingType':
          return this.trackings.some(tracking => tracking.WERTUNGSART);
        case 'order':
          return this.trackings.some(tracking => tracking.AUFTRAGSNR);
        case 'project':
          return this.trackings.some(tracking => tracking.PROJEKTNR);
        case 'bemi':
          return this.trackings.some(tracking => tracking.BEMINR);
        case 'pos':
          return this.trackings.some(tracking => tracking.BEMIPOS);
        case 'incident':
          return this.trackings.some(tracking => tracking.VORFALLNAME);
        case 'comment':
          return this.trackings.some(tracking => tracking.BEMERKUNG);
      }
    })
  }

}
